module.exports = __webpack_public_path__ + "static/media/ios.094c5f60.png";